var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedFilledClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16678 16.4861C12.3012 16.4861 15.6529 13.1345 15.6529 9.00003C15.6529 4.86556 12.3012 1.51392 8.16678 1.51392C4.03231 1.51392 0.680664 4.86556 0.680664 9.00003C0.680664 13.1345 4.03231 16.4861 8.16678 16.4861ZM8.84733 8.31947H11.5696V9.68058H7.48622V4.23614H8.84733V8.31947Z",
    fill: "#FFAD0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedFilledClock);
export default __webpack_public_path__ + "static/media/rounded-filled-clock.259d64f6458b2ae5b6b1a697d6cb7a61.svg";
export { ForwardRef as ReactComponent };